const orderItem = `
  id
  clientId
  individualId
  restaurantId
  elderId
  date
  mealSlot
  deliveryBy
  status
  county
  category
  transactionId
  deliveryGroupId
  deliveryGroupSortOrder
  source
  groupPurchaseStatus
  orderQuoteId
  deliveryStaffId
  deliveryStaffOrderId
  deliveryStaffFee
  deliveryStaffFeeCalculationMethod
  noteForDelivery
  noteForMeal
  note
  groupPurchaseDietaryNote
  mealItems {
    name
    quantity
    price
    cost
    note
    surcharges {
      name
      price
    }
  }
  totalCost
  total
  quantity
  subtotal
  extraFee
  platformFee
  paymentMethod
  elder {
    id
    name
  }
  orderGroupId
  referenceId
  linkGroupElderIds
  cancellationReason
  cancellationNote
  directionServiceProvider
  restaurant {
    id
    name
  }
`;

export const getOrdersByClientByDate = /* GraphQL */ `
  query GetOrdersByClientByDate(
    $clientId: ID
    $date: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelOrderFilterInput
    $limit: Int
    $nextToken: String
  ) {
    getOrdersByClientByDate(
      clientId: $clientId
      date: $date
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        ${orderItem}
      }
      nextToken
    }
  }
`;

export const getOrdersByElderByDate = /* GraphQL */ `
  query GetOrdersByElderByDate(
    $elderId: ID
    $date: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelOrderFilterInput
    $limit: Int
    $nextToken: String
  ) {
    getOrdersByElderByDate(
      elderId: $elderId
      date: $date
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        ${orderItem}
      }
      nextToken
    }
  }
`;
